/**
 * 在GestureFloat的外层包了一个QPopupLayer,
 * 在使用时，可以将QGestureFloat 添加到任何视图节点；且需要遵循QPopupLayer的使用规则
 */
import React from 'react';
import { DeviceInfo } from 'qunar-react-native';
import { verUtil } from '@qnpm/q-design-utils';
import { QPopupLayer } from '@qnpm/q-popup-layer';
import { GestureFloat } from './GestureFloat';
export class QGestureFloat extends React.Component {
    render() {
        //为6月底版本及以上才支持手势浮层
        const supportQGestureFloat = verUtil.overVer.overV3;
        if (!supportQGestureFloat) {
            // eslint-disable-next-line no-console
            console.warn('此native版本不支持QGestureFloat: overV3: ' +
                DeviceInfo.qrn_version);
            return null;
        }
        const { pageNumber, onRef, onFloatClose, onPopLayerShow } = this.props;
        return (<QPopupLayer visible={pageNumber > -2} hasHeader={false} perHeight={100} onClose={onFloatClose} animationType="none" onShow={onPopLayerShow} style={{ backgroundColor: 'transparent' }}>
                <GestureFloat ref={onRef} {...this.props}/>
            </QPopupLayer>);
    }
}
